var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    modalType: [],
};
export var modalSlice = createSlice({
    name: 'modal',
    initialState: initialState,
    reducers: {
        openModal: function (state, action) {
            state.modalType = __spreadArray(__spreadArray([], state.modalType, true), [action.payload], false);
        },
        closeModal: function (state, action) {
            state.modalType = action.payload;
        },
    },
});
export var openModal = (_a = modalSlice.actions, _a.openModal), closeModal = _a.closeModal;
export var modalReducer = modalSlice.reducer;
